var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"date  white--text ",staticStyle:{"padding-left":"5px","padding-right":"5px"}},[_vm._v(_vm._s(_vm.digitalClock.date)+" "+_vm._s(_vm.digitalClock.time))])}
var staticRenderFns = []

export { render, staticRenderFns }